import { render, staticRenderFns } from "./u-notice.html?vue&type=template&id=5e07cab9&scoped=true&"
import script from "./u-notice.js?vue&type=script&lang=js&"
export * from "./u-notice.js?vue&type=script&lang=js&"
import style0 from "./u-notice.scss?vue&type=style&index=0&id=5e07cab9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07cab9",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports